import { useLayoutEffect, useRef } from 'react';

const AutoTextarea = ({
  value = '',
  onChange,
  isEditor = false,
  rows = 1,
  className = '',
  textClassName = '',
  textareaClassName = '',
  required = false
}) => {
  const ref = useRef(null);

  const adjustHeight = () => {
    const el = ref.current;
    if (!el) return;

    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };

  useLayoutEffect(() => {
    const frame = requestAnimationFrame(() => {
      adjustHeight();
    });

    const handleResize = () => {
      adjustHeight();
    };

    window.addEventListener('resize', handleResize);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', handleResize);
    };
  }, [value]);

  if (!isEditor) {
    return (
      <span className={`whitespace-pre-line break-words ${textClassName}`}>
        {value}
      </span>
    );
  }

  return (
    <textarea
      ref={ref}
      value={value}
      rows={rows}
      onChange={onChange}
      onInput={adjustHeight}
      required={required}
      className={`
        w-full min-w-0 box-border rounded-md border border-gray-300 bg-white px-2 py-1 text-sm
        resize-none overflow-hidden leading-5 cursor-text
        hover:border-purple-400
        focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500
        ${textareaClassName}
        ${className}
      `}
    />
  );
};

export default AutoTextarea;
